<template>
    <div>
        <q-content-submenu></q-content-submenu>
        <v-container fluid class="px-5 transparent q-sticky-buffer">
            <v-row class="mx-5">
                <v-col cols=12>
                    <v-card class="py-2">
                        <v-alert border="left" outlined type="info" class="mb-0 mx-3">
                            <p class="mb-0">
                                Not all carriers feed their pending case data and status to Quility, but you can view this information directly on the carrier's agent portal.
                                <router-link to="/new_business/carrier_portal" class="font-weight-bold">Click here for a list of carriers and the status of received data.</router-link>
                            </p>
                        </v-alert>

                        <q-pending-policy-data-table :agent="getAgent" :rows="25" title="Pending Policies" :stat-type="this.$route.query.statType" :start-date="startDate" :end-date="endDate" v-on:resetparams="resetParams()"></q-pending-policy-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
//table data + search
import QPendingPolicyDataTable from '@/components/datatables/QPendingPolicyDataTable.vue';
import QContentSubmenu from '@/components/navigation/Submenus/QContentSubmenu.vue';
import QTabs from '../../components/navigation/QTabs.vue'


export default {
    data() {
        return {
            search: '',
            is_reset : false
        }
    },
    mounted: function() {},
    computed: {
        getAgent: function() {
            if (this.hasRole(['SuperAdmin', 'Staff'])){
                return {"AgentCode" : this.current_tenant.TopLevelAgentCode};
            }
            return this.user.Agent
        },
        startDate () {
            return this.is_reset ? null : this.$route.params.startDate
        },
        endDate () {
            return this.is_reset ? null : this.$route.params.endDate
        },
    },
    methods: {
        resetParams : function(){
            this.is_reset = true
        }
    },

    watch : {
        '$route.params.agent_code' : function(){
            this.is_reset = false
        }
    },
    components: {
        QPendingPolicyDataTable,
        QTabs,
        QContentSubmenu
    },
}
</script>